import { render, staticRenderFns } from "./send-collect-customer.vue?vue&type=template&id=76f6e743&scoped=true&"
import script from "./send-collect-customer.vue?vue&type=script&lang=ts&"
export * from "./send-collect-customer.vue?vue&type=script&lang=ts&"
import style0 from "./send-collect-customer.vue?vue&type=style&index=0&id=76f6e743&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f6e743",
  null
  
)

export default component.exports